import { render, staticRenderFns } from "./ReviewsLaundry.vue?vue&type=template&id=7fe9a086&scoped=true"
import script from "./ReviewsLaundry.vue?vue&type=script&lang=js"
export * from "./ReviewsLaundry.vue?vue&type=script&lang=js"
import style0 from "./ReviewsLaundry.vue?vue&type=style&index=0&id=7fe9a086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9a086",
  null
  
)

export default component.exports